<template>
  <modal :title="title" :saving="saving" @hide-modal="$emit('hide-modal')">
    <div class="d-flex flex-wrap font-bold">
      <div class="mr-1">Equipment at</div>
      <address-label :address="address" single></address-label>
    </div>
    <customer-equipment-datatable
      source="/reports/equipment_overview.json?values_only=true"
      :customer-id="address.owner_id"
      :address-id="address.id"
      :show-archived="false"
    ></customer-equipment-datatable>
    <div class="font-bold mb-2 customer-label">
      Appointment for {{ fullName(customer) }}
    </div>
    <div class="form-container mb-3">
      <schedule-appointment-module
        v-if="address"
        ref="form"
        :address="address"
      ></schedule-appointment-module>
    </div>
    <FeatureFlag feature="appointment_updates">
      <div v-if="job.appointments.length">
        <div class="font-bold mb-2">Appointments for Job #{{ job.id }}</div>
        <appointments-datatable
          ref="appointmentsDatatable"
          source="/reports/appointments"
          :job-id="job.id"
          hide-header
        ></appointments-datatable>
      </div>
    </FeatureFlag>
    <TagListCard class="mt-8" @edit-profile="emit('edit-profile')" />
    <template #submit>
      <div class="flex gap-4 items-center">
        <FeatureFlag class="d-inline-block" feature="appointment_updates">
          <Button :disabled="saving" outline @click="handleSave(true)">
            <span v-if="!saving">Save & Add Another</span>
            <spinner v-else message="Saving..."></spinner>
          </Button>
        </FeatureFlag>
        <Button :disabled="saving" @click="handleSave(false)">
          <span v-if="!saving">Save</span>
          <spinner v-else message="Saving..."></spinner>
        </Button>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapActions } from "vuex";

import AddressLabel from "@/components/AddressLabel.vue";
import Button from "@/components/Button.vue";
import FeatureFlag from "@/components/FeatureFlag.vue";
import Modal from "@/components/Modal.vue";
import Spinner from "@/components/Spinner.vue";
import CustomerEquipmentDatatable from "@/Equipment/CustomerEquipmentDatatable.vue";
import TagListCard from "@/Job/TagListCard.vue";
import AppointmentsDatatable from "./AppointmentsDatatable.vue";
import ScheduleAppointmentModule from "./ScheduleAppointmentModule.vue";

export default {
  components: {
    Modal,
    CustomerEquipmentDatatable,
    AppointmentsDatatable,
    AddressLabel,
    ScheduleAppointmentModule,
    Spinner,
    FeatureFlag,
    TagListCard,
    Button
  },
  props: {
    job: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      saving: false
    };
  },
  computed: {
    address() {
      return this.job.address;
    },
    customer() {
      return this.job.customer;
    },
    title() {
      return `Add Appointment to Job #${this.job.id}`;
    }
  },
  methods: {
    ...mapActions(["createAppointment", "fetchJob"]),
    handleSave(keepOpen = false) {
      this.$refs.form.validate().then((isValid) => {
        if (!isValid) return;

        this.saving = true;
        const payload = this.$refs.form.getFormData();
        this.createAppointment({
          link: this.job.links.appointment_create,
          payload
        })
          .then(() => {
            this.fetchJob({ jobId: this.job.id });

            if (!keepOpen) {
              this.$emit("hide-modal");
            } else {
              this.$refs.form.resetFormData();
              this.validator.reset();

              if (this.$refs.appointmentsDatatable) {
                this.$refs.appointmentsDatatable.refreshTable();
              }

              window.notify.success("Appointment created successfully!");
            }

            this.saving = false;
          })
          .catch(() => (this.saving = false));
      });
    }
  },
  provide() {
    return {
      job: this.job
    };
  }
};
</script>

<style lang="scss" scoped>
.customer-label {
  margin-top: 10px;
}
</style>
